import React from 'react'
import tw from 'tailwind-styled-components'
import {Util} from 'yougile-util'
import {DragData} from '@common/drag-data'
import {UserStatus} from '@components/common/user-status/user-status'
import {cn} from '@containers/html-utils'
import {UserProxy} from '@extensions/proxies/user-proxy'
import AdminIcon from './icon-admin.svg'

const TwAdminIcon = tw.div`
  -bottom-2
  absolute
  flex
  justify-center
  text-bg-main
  w-full
`

interface UserAvatarV2Props extends UserProxy {
  readonly hideStatus?: boolean
  readonly withBorder?: boolean
  readonly withMainBorder?: boolean
  readonly withAdminIcon?: boolean
  readonly statusBackground?: 'default' | 'dark'
  readonly size?: number
  className?: string
}

export const UserAvatarV2 = (props: UserAvatarV2Props) => {
  const {
    userId,
    userImage,
    userStatus,
    userInfo,
    userEmail,
    userName,
    userShortName,
    userBackgroundColor,
    userIsInDoNotDisturbMode,
    statusBackground = 'default',
    size = 30,
    hideStatus,
    withBorder,
    withMainBorder,
    withAdminIcon,
    userIsAdmin,
    className
  } = props

  const bem = Util.bemFrom('user-avatar-v2')

  const style = {
    background: userBackgroundColor,
    width: size + 'px',
    height: size + 'px',
    fontSize: size * 0.4375 + 'px'
  }

  const image = (
    <div
      className={bem('image')}
      style={{backgroundImage: `url("${userImage}")`}}
    />
  )

  const status = (
    <div className={cn(bem('status'), withAdminIcon ? '-ml-1' : '')}>
      <UserStatus
        userStatus={userStatus}
        userIsInDoNotDisturbMode={userIsInDoNotDisturbMode}
        statusBackground={statusBackground}
      />
    </div>
  )
  const dragStart = (e: React.DragEvent<HTMLElement>) => {
    DragData.set(e, {type: 'user', userId})
  }

  const mainClass = [
    bem({withBorder, invited: userEmail === userName}),
    className
  ].join(' ')

  return (
    <div
      className={cn(
        mainClass,
        withAdminIcon ? 'relative' : '',
        withMainBorder ? 'border-solid border-bg-main border-1' : ''
      )}
      style={style}
      title={userInfo}
      draggable={true}
      onDragStart={dragStart}
    >
      {withAdminIcon && userIsAdmin && (
        <TwAdminIcon>
          <AdminIcon />
        </TwAdminIcon>
      )}
      <div className={bem('short-name')}>{userShortName}</div>
      {userImage && image}
      {!hideStatus && status}
    </div>
  )
}
